import axios from 'axios';
import { BASE_URL } from '../../variables/common';

export const getDeviceStream = (udid) => async (dispatch) => {
    let _url = "testURL";
    _url = await axios({
        method: 'GET',
        url: `${BASE_URL}/client/device/${udid}/stream`,
    })
        .then((response) => {
            return response.data
        })
        .catch((error) => {
            return undefined
        });

    return _url
};